import { render, staticRenderFns } from "./BindsSwitch.vue?vue&type=template&id=5f764de4&"
import script from "./BindsSwitch.vue?vue&type=script&lang=js&"
export * from "./BindsSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BindsSwitch.vue?vue&type=style&index=0&id=5f764de4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports